import { memo } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import moment from 'moment-mini';
import { NotificationState } from 'root/src/shared/notification/notification.types';
import { Tooltip, TooltipTrigger, TooltipContent } from 'root/src/client/v2/common/components/ui/tooltip';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { NOTIFICATION_MARKDOWN_COMPONENTS } from 'root/src/client/v2/notifications/redesign/notificationMarkdown';
export const NotificationItem = memo(({ notification, onMarkRead, onOpen }) => {
    const isUnread = notification.state === NotificationState.Unread;
    const createdAt = moment(notification.created);
    // Clicking the row opens the notification in the modal, but let inner links and the inline
    // action buttons (Mark as read, time tooltip trigger) handle their own clicks.
    const handleActivate = (event) => {
        if (event.target.closest('a, button')) {
            return;
        }
        onOpen(notification);
    };
    return (<div role="button" tabIndex={0} onClick={handleActivate} onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleActivate(event);
            }
        }} className={cn('cursor-pointer px-4 py-3 outline-none transition-colors hover:bg-white/[0.05] focus-visible:bg-white/[0.05]', isUnread && 'bg-white/[0.03]')}>
			<div className="flex gap-3">
				<span aria-hidden="true" className={cn('mt-1.5 h-2 w-2 shrink-0 rounded-full', isUnread ? 'bg-neon-cyan shadow-[0_0_8px_-1px_hsl(var(--neon-cyan)/0.9)]' : 'bg-transparent')}/>
				<div className="min-w-0 flex-1">
					<div className={cn('line-clamp-3 break-words text-sm leading-relaxed', isUnread ? 'text-foreground' : 'text-muted-foreground')}>
						<Markdown remarkPlugins={[remarkGfm]} components={NOTIFICATION_MARKDOWN_COMPONENTS}>
							{notification.content}
						</Markdown>
					</div>
					<div className="mt-1.5 flex items-center gap-2.5">
						<Tooltip>
							<TooltipTrigger asChild>
								<span className="cursor-default text-[11px] text-muted-foreground">{createdAt.fromNow()}</span>
							</TooltipTrigger>
							<TooltipContent>{createdAt.format('MMM D, YYYY, h:mm A')}</TooltipContent>
						</Tooltip>
						{isUnread && (<button type="button" onClick={() => onMarkRead(notification.id)} className="text-[11px] font-medium text-neon-cyan transition-opacity hover:opacity-80">
								Mark as read
							</button>)}
					</div>
				</div>
			</div>
		</div>);
});
NotificationItem.displayName = 'NotificationItem';
